import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../Shared/Styles/ContainerStyles";

import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import BrokersTable from "./BrokersTable";
import Paper from "@material-ui/core/Paper";

import { AddIcon } from "../../Shared/Components/Icons";
import InviteBroker from "./InviteBroker";
//import InvitationModal from "../../Shared/Components/InvitationModal";

class BrokersContainer extends React.Component {
  state = {
    invitationModalOpen: false
  };

  handleOpen = () => {
    this.setState({ invitationModalOpen: true });
  };

  handleRefreshChildTable = () => {
    this.refreshChildTable()
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <InviteBroker
          enqueueSnackbar={this.props.enqueueSnackbar}
          Employer={this.props.reformUser.employer_id}
          Inviter={this.props.reformUser.profile_id}
          Open={this.state.invitationModalOpen}
          Close={() => {
            this.setState({ invitationModalOpen: false });
          }}
          RefreshTable={this.handleRefreshChildTable}
        />
        <div className={classes.containerRoot}>
          <div style={{ height: 0 }}>
            <Fab
              color="primary"
              aria-label="Add"
              className={classes.fab}
              onClick={this.handleOpen}
            >
              <AddIcon />
            </Fab>
          </div>
          <div className={classes.containerContent}>
            <div style={{ height: 0 }} />
            <Paper
              className={classes.containerPaper}
              style={{ overflow: "hidden" }}
            >
              <BrokersTable history={this.props.history} enqueueSnackbar={this.props.enqueueSnackbar} setRefresh={func => (this.refreshChildTable = func)}/> 
            </Paper>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

BrokersContainer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(BrokersContainer);